import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-servicing',
  templateUrl: './servicing.component.html',
  styleUrls: ['./servicing.component.css']
})
export class ServicingComponent implements OnInit {
  loaderMode = false;

  constructor() { }

  ngOnInit() {
  	this.loaderMode = true;
  	console.log('loaderMode ' , this.loaderMode) ;
  	setTimeout(() => {
	     this.loaderMode = false;
	   }, 300);
  }

}
